export class Quotation {
    serviceType: string;
    budget: number;
    destination: string;
    attendees: number;
    startDate: string;
    endDate: string;
    remark: string;
    contactName: string;
    companyName: string;
    phone: string;
    email: string;
    lang: string;
}

export class QuotationResponse {
    miceQuotationCode: string;
    miceQuotationId: number;
}

export class GalleryItem {
    topic: string;
    description: string;
    map: string;
}

export class GalleryContent {
    th: GalleryItem;
    en: GalleryItem;
    folderName: string;
    gallery: string[];
}

export class GalleryList {
    data: GalleryContent[] = [];
}


// WEBPACK FOOTER //
// ./src/app/model/mice/mice.model.ts